var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"min-height":210}},[_c('v-card-title',[_vm._v(" Internet Traffic Details "),_c('v-spacer')],1),_c('v-card-text',[_c('internet-traffic-details-graph',{attrs:{"url":_vm.url}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }